import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Card as CardBase } from '@leroy-merlin-br/backyard-react-ui'

const suggestionsStyles = ({ theme }) => css`
  label: suggestions;

  position: absolute;
  z-index: ${theme.zIndex.modal + 1};
  width: 100%;
  padding: 0px;

  ${theme.media.mega} {
    padding: 0px;
  }

  & > div {
    padding: 0px;
  }
`

const suggestionsItemStyles = ({ theme }) => css`
  label: suggestions__item;

  width: 100%;
  padding: ${theme.spacings.byte} ${theme.spacings.mega};

  cursor: pointer;

  text-align: left;
  color: ${theme.colors.n400};
  font-size: ${theme.typography.subHeadings.mega.fontSize};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};

  &:hover {
    background-color: ${theme.colors.p600};
    color: ${theme.colors.white};
  }

  &:first-of-type {
    border-top-left-radius: ${theme.borderRadius.mega};
    border-top-right-radius: ${theme.borderRadius.mega};
  }

  &:last-of-type {
    border-bottom-left-radius: ${theme.borderRadius.mega};
    border-bottom-right-radius: ${theme.borderRadius.mega};
  }
`

export const Suggestions = styled(CardBase)(suggestionsStyles)
export const SuggestionsItem = styled('div')(suggestionsItemStyles)
